import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoService {

  constructor(private http: HttpClient) {}

  private _UrlSolicitacao = environment.UrlPrincipal + '/api/solicitacao';
  private _UrlSolicitacaoConfirmar = environment.UrlPrincipal + '/api/solicitacaoconfirmar';

  list() {
    return this.http.get(this._UrlSolicitacao)
                    .catch(this.handleError);
  }

  realizadas() {
    return this.http.get(this._UrlSolicitacao + "-realizadas")
                    .catch(this.handleError);
  }

  find(id) {
    return this.http.get(this._UrlSolicitacao + "/" + id)
                    .catch(this.handleError);
  }

  save(dados, codigo_pessoa): Observable<any>{   
    let http;
    if(codigo_pessoa || dados.codigo_pessoa){
        http = this.http.put(this._UrlSolicitacao + "/" + dados.codigo_pessoa, dados);
    } else {
        http = this.http.post(this._UrlSolicitacao, dados);
    }
    http.map((res) => {
        return res;
    }).catch(this.handleError);
    return http;
  }

  confirmar(dados): Observable<any>{   
    let http;
    http = this.http.post(this._UrlSolicitacaoConfirmar, dados);
    http.map((res) => {
        return res;
    }).catch(this.handleError);
    return http;
  }

  delete(codigo_pessoa) {
    return this.http.delete(this._UrlSolicitacao + "/" + codigo_pessoa);
  }

  private handleError(error: Response) {
    return error.json();
  }

}